<template>
  <div class='cc'>
    <div class='head-list'>
      <div v-for='(item, index) in headList' :key='index'>
        <div class='num'>{{item.value}}</div>
        <div class='text'>{{item.name}}{{item.unit}}</div>
      </div>
    </div>
    <div class='line1'>
      <!-- <div class='content w-30' style='position:relative'>
        <div class='top'><div class='icon'></div>仓储库存</div>
        <div class='title'>
          <div>销售总金额：1000万</div>
          <div>订单笔数：10000单</div>
        </div>
        <div id='cc-charts1'></div>
        <div id='tips' @click='tipsShow = false' v-show='tipsShow'>
          <div>{{tips.name}}</div>
          <div>库存数量:{{tips.line1}}</div>
          <div>库存金额:{{tips.line2}}</div>
        </div>
      </div> -->
      <div class='content w-100'>
        <div class='top'><div class='icon'></div>库存数量/金额变动趋势图</div>
        <!-- <div class='title'>
          <div>销售总金额：1000万</div>
          <div>订单笔数：10000单</div>
        </div> -->
        <div id='cc-charts2'></div>
      </div>
    </div>
    <div class='line1'>
      <div class='content w-30'>
        <div class='top'><div class='icon'></div>库龄数量统计</div>
        <!-- <div class='title'>
          <div>销售总金额：1000万</div>
          <div>订单笔数：10000单</div>
        </div> -->
        <div id='cc-charts3'></div>
      </div>
      <div class='content w-70'>
        <div class='top'><div class='icon'></div>商品库存TOP10</div>
        <div class='filter-list'>
          <!-- <div class='filter-item'>
            <div class='filter-text'>选择国家</div>
            <el-select
              class='el-input-dark mr-16px'
              v-model='filter.country'
              placeholder='选择国家'
              @change='getList'
              clearable
              filterable>
              <el-option v-for='(item, index) in countryList' :key='index' :value='item.countryCode' :label='item.countryName' />
            </el-select>
          </div> -->
          <div class='filter-item'>
            <div class='filter-text'>选择仓库</div>
            <el-select
              class='el-input-dark mr-16px'
              v-model='filter.warehouse'
              placeholder='选择仓库'
              @change='loadProductStored'
              clearable
              filterable>
              <el-option v-for='(item, index) in warehouseList' :key='index' :value='item.warehouse_id' :label='item.warehouse_name' />
            </el-select>
          </div>
        </div>
        <div class='ux-tabs tabs'>
          <div class='ux-filter-records filter-records'>
            <div class='content-list' style='height:auto'>
              <el-table
                class='table ux-dark-el-table'
                :data='tableData'
                max-height="440"
                empty-text="暂无数据"
                element-loading-spinner='el-icon-loading'>
                <el-table-column width='80' type='index' label='序号' align='center'>
                  </el-table-column>
                  <el-table-column :show-overflow-tooltip='true' v-for='(props, i) in tableHeader' :label='props.label' align='center' :key='i'>
                    <template slot-scope='scope'>
                      <el-tooltip
                        popper-class='ux-dark-el-tooltip'
                        effect='dark'
                        placement='top'
                        :content='scope.row[props.prop]'
                        :open-delay='300'>
                        <div class='text'>{{ scope.row[props.prop] || '' }}</div>
                      </el-tooltip>
                     </template>
                  </el-table-column>
                  <!-- <el-table-column label='操作' align='center'>
                    <template slot-scope='scope'>
                      <div class='blue'>查看详情</div>
                    </template>
                  </el-table-column> -->
              </el-table>
            </div>
            <!-- <div class='pages'>
              <span>共 {{ page.total }} 条数据</span>
              <el-pagination
                class='ux-dark-el-pagination'
                small
                background
                layout='prev, pager, next'
                :current-page='page.current'
                :page-size='page.size'
                :total='page.total'
                @current-change='currentChange'
              />
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import common from '@/utils/common'
// import languageObj from '@/utils/lan.json'
// import world from '@/components/main/bigData/home/components/map/json/world.json'
import world from './json/world.json'
import apiPath from '@config/api.json'
const {mapState, mapMutations} = require('vuex')
export default {
  components: {},
  props: ['info'],
  data () {
    return {
      tableHeader: [
        {
          prop: 'title',
          label: '商品名称'
        },
        {
          prop: 'warehouseName',
          label: '仓库名称'
        },
        // {
        //   prop: 'warehouseCountry',
        //   label: '仓库国家'
        // },
        {
          prop: 'availableQty',
          label: '库存数量（件）'
        },
        {
          prop: 'stockTurnover',
          label: '周转率（%）'
        }
      ],
      tableData: [],
      headList: [],
      topInventoryAgeQuantitySummary: {},
      topInventoryDetailSummary: [],
      topQuantityAmountTrendChartSummary: [],
      topStorageInventorySummary: [],
      filter: {
        country: '全部国家',
        searchTime: '2022',
        warehouse: '全部仓库'
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      tips: {},
      tipsShow: false,
      summary: {}
    }
  },

  computed: {
    ...mapState({
      searchDate: (state) => {
        return state.home.searchDate
      },
      warehouseList: (state) => {
        return state.home.warehouseList
      },
      countryList: (state) => {
        return state.home.countryList
      }
    })
  },

  watch: {
    searchDate: function (n) {
      this.init()
    }
  },

  created () {
  },

  mounted () {
    this.init()
  },

  methods: {
    ...mapMutations(),
    init () {
      // 企业仓储库存表
      this.loadStatistics()
      // 库存变动趋势表
      this.loadStoredTrend()
      // 商品库存表
      this.loadProductStored()
      // 库龄数量统计
      this.loadStoredQuantityStatistics()
    },
    // 企业仓储库存表
    loadStatistics () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.cc.getEnterpriseGoodsStored}${this.info.customerNo}`
      }).then(res => {
        const dataInfo = res.data || {}
        this.headList = [
          {
            name: '库存商品数',
            value: dataInfo.availableQty || '0',
            unit: '（个）'
          },
          {
            name: '库存金额',
            value: dataInfo.totalPrice || '0',
            unit: '（元）'
          }, {
            name: '存销比',
            value: dataInfo.stockSaleRatio || '0',
            unit: ''
          }, {
            name: '周转率',
            value: dataInfo.stockTurnover || '0%',
            unit: '（%）'
          }
        ]
      })
    },
    // 库存变动趋势表
    loadStoredTrend () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.cc.getStoredTrend}${this.info.customerNo}`
      }).then(res => {
        console.log('库存变动趋势表', res)
        const dataInfo = res.data || []
        this.topQuantityAmountTrendChartSummary = dataInfo
        this.initCharts2()
      })
    },
    // 库存变动趋势表
    loadProductStored () {
      this.$ajax({
        method: 'post',
        url: apiPath.bigData.search.cc.getProductStored,
        data: {
          customerNo: this.info.customerNo,
          warehouseId: this.filter.warehouse === '全部仓库' ? '' : this.filter.warehouse
        }
      }).then(res => {
        this.tableData = res.data || []
      })
    },
    // 库龄数量统计
    loadStoredQuantityStatistics () {
      this.$ajax({
        method: 'get',
        url: `${apiPath.bigData.search.cc.getStoredQuantityStatistics}${this.info.customerNo}`
      }).then(res => {
        const dataInfo = res.data || []
        this.topInventoryAgeQuantitySummary = dataInfo
        this.initCharts3()
      })
    },
    initCharts1 () {
      let data = {}
      let json = {
        '中国': 'China',
        'US': 'United States'
        // 'Afghanistan': '阿富汗',
        // 'Angola': '安哥拉',
        // 'Albania': '阿尔巴尼亚',
        // 'United Arab Emirates': '阿联酋',
        // 'Argentina': '阿根廷',
        // 'Armenia': '亚美尼亚',
        // 'French Southern and Antarctic Lands': '法属南半球和南极领地',
        // 'Australia': '澳大利亚',
        // 'Austria': '奥地利',
        // 'Azerbaijan': '阿塞拜疆',
        // 'Burundi': '布隆迪',
        // 'Belgium': '比利时',
        // 'Benin': '贝宁',
        // 'Burkina Faso': '布基纳法索',
        // 'Bangladesh': '孟加拉国',
        // 'Bulgaria': '保加利亚',
        // 'The Bahamas': '巴哈马',
        // 'Bosnia and Herzegovina': '波黑',
        // 'Belarus': '白俄罗斯',
        // 'Belize': '伯利兹',
        // 'Bermuda': '百慕大',
        // 'Bolivia': '玻利维亚',
        // 'Brazil': '巴西',
        // 'Brunei': '文莱',
        // 'Bhutan': '不丹',
        // 'Botswana': '博茨瓦纳',
        // 'Central African Republic': '中非共和国',
        // 'Canada': '加拿大',
        // 'Switzerland': '瑞士',
        // 'Chile': '智利',
        // 'China': '中国',
        // 'Ivory Coast': '象牙海岸',
        // 'Cameroon': '喀麦隆',
        // 'Democratic Republic of the Congo': '刚果（金）',
        // 'Republic of the Congo': '刚果（布）',
        // 'Colombia': '哥伦比亚',
        // 'Costa Rica': '哥斯达黎加',
        // 'Cuba': '古巴',
        // 'Northern Cyprus': '北塞浦路斯',
        // 'Cyprus': '塞浦路斯',
        // 'Czech Republic': '捷克',
        // 'Germany': '德国',
        // 'Djibouti': '吉布提',
        // 'Denmark': '丹麦',
        // 'Dominican Republic': '多米尼加共和国',
        // 'Algeria': '阿尔及利亚',
        // 'Ecuador': '厄瓜多尔',
        // 'Egypt': '埃及',
        // 'Eritrea': '厄立特里亚',
        // 'Spain': '西班牙',
        // 'Estonia': '爱沙尼亚',
        // 'Ethiopia': '埃塞俄比亚',
        // 'Finland': '芬兰',
        // 'Fiji': '斐',
        // 'Falkland Islands': '福克兰群岛',
        // 'France': '法国',
        // 'Gabon': '加蓬',
        // 'United Kingdom': '英国',
        // 'Georgia': '格鲁吉亚',
        // 'Ghana': '加纳',
        // 'Guinea': '几内亚',
        // 'Gambia': '冈比亚',
        // 'Guinea Bissau': '几内亚比绍',
        // 'Equatorial Guinea': '赤道几内亚',
        // 'Greece': '希腊',
        // 'Greenland': '格陵兰',
        // 'Guatemala': '危地马拉',
        // 'French Guiana': '法属圭亚那',
        // 'Guyana': '圭亚那',
        // 'Honduras': '洪都拉斯',
        // 'Croatia': '克罗地亚',
        // 'Haiti': '海地',
        // 'Hungary': '匈牙利',
        // 'Indonesia': '印度尼西亚',
        // 'India': '印度',
        // 'Ireland': '爱尔兰',
        // 'Iran': '伊朗',
        // 'Iraq': '伊拉克',
        // 'Iceland': '冰岛',
        // 'Israel': '以色列',
        // 'Italy': '意大利',
        // 'Jamaica': '牙买加',
        // 'Jordan': '约旦',
        // 'Japan': '日本',
        // 'Kazakhstan': '哈萨克斯坦',
        // 'Kenya': '肯尼亚',
        // 'Kyrgyzstan': '吉尔吉斯斯坦',
        // 'Cambodia': '柬埔寨',
        // 'South Korea': '韩国',
        // 'Kosovo': '科索沃',
        // 'Kuwait': '科威特',
        // 'Laos': '老挝',
        // 'Lebanon': '黎巴嫩',
        // 'Liberia': '利比里亚',
        // 'Libya': '利比亚',
        // 'Sri Lanka': '斯里兰卡',
        // 'Lesotho': '莱索托',
        // 'Lithuania': '立陶宛',
        // 'Luxembourg': '卢森堡',
        // 'Latvia': '拉脱维亚',
        // 'Morocco': '摩洛哥',
        // 'Moldova': '摩尔多瓦',
        // 'Madagascar': '马达加斯加',
        // 'Mexico': '墨西哥',
        // 'Macedonia': '马其顿',
        // 'Mali': '马里',
        // 'Myanmar': '缅甸',
        // 'Montenegro': '黑山',
        // 'Mongolia': '蒙古',
        // 'Mozambique': '莫桑比克',
        // 'Mauritania': '毛里塔尼亚',
        // 'Malawi': '马拉维',
        // 'Malaysia': '马来西亚',
        // 'Namibia': '纳米比亚',
        // 'New Caledonia': '新喀里多尼亚',
        // 'Niger': '尼日尔',
        // 'Nigeria': '尼日利亚',
        // 'Nicaragua': '尼加拉瓜',
        // 'Netherlands': '荷兰',
        // 'Norway': '挪威',
        // 'Nepal': '尼泊尔',
        // 'New Zealand': '新西兰',
        // 'Oman': '阿曼',
        // 'Pakistan': '巴基斯坦',
        // 'Panama': '巴拿马',
        // 'Peru': '秘鲁',
        // 'Philippines': '菲律宾',
        // 'Papua New Guinea': '巴布亚新几内亚',
        // 'Poland': '波兰',
        // 'Puerto Rico': '波多黎各',
        // 'North Korea': '朝鲜',
        // 'Portugal': '葡萄牙',
        // 'Paraguay': '巴拉圭',
        // 'Qatar': '卡塔尔',
        // 'Romania': '罗马尼亚',
        // 'Russia': '俄罗斯',
        // 'Rwanda': '卢旺达',
        // 'Western Sahara': '西撒哈拉',
        // 'Saudi Arabia': '沙特阿拉伯',
        // 'Sudan': '苏丹',
        // 'South Sudan': '南苏丹',
        // 'Senegal': '塞内加尔',
        // 'Solomon Islands': '所罗门群岛',
        // 'Sierra Leone': '塞拉利昂',
        // 'El Salvador': '萨尔瓦多',
        // 'Somaliland': '索马里兰',
        // 'Somalia': '索马里',
        // 'Republic of Serbia': '塞尔维亚',
        // 'Suriname': '苏里南',
        // 'Slovakia': '斯洛伐克',
        // 'Slovenia': '斯洛文尼亚',
        // 'Sweden': '瑞典',
        // 'Swaziland': '斯威士兰',
        // 'Syria': '叙利亚',
        // 'Chad': '乍得',
        // 'Togo': '多哥',
        // 'Thailand': '泰国',
        // 'Tajikistan': '塔吉克斯坦',
        // 'Turkmenistan': '土库曼斯坦',
        // 'East Timor': '东帝汶',
        // 'Trinidad and Tobago': '特里尼达和多巴哥',
        // 'Tunisia': '突尼斯',
        // 'Turkey': '土耳其',
        // 'United Republic of Tanzania': '坦桑尼亚',
        // 'Uganda': '乌干达',
        // 'Ukraine': '乌克兰',
        // 'Uruguay': '乌拉圭',
        // 'United States of America': '美国',
        // 'Uzbekistan': '乌兹别克斯坦',
        // 'Venezuela': '委内瑞拉',
        // 'Vietnam': '越南',
        // 'Vanuatu': '瓦努阿图',
        // 'West Bank': '西岸',
        // 'Yemen': '也门',
        // 'South Africa': '南非',
        // 'Zambia': '赞比亚',
        // 'Zimbabwe': '津巴布韦',
        // 'Singapore Rep.': '新加坡',
        // 'Dominican Rep.': '多米尼加',
        // 'Palestine': '巴勒斯坦',
        // 'Bahamas': '巴哈马',
        // 'Timor-Leste': '东帝汶',
        // 'Guinea-Bissau': '几内亚比绍',
        // 'Côte d Ivoire': '科特迪瓦',
        // 'Siachen Glacier': '锡亚琴冰川',
        // 'Br. Indian Ocean Ter.': '英属印度洋领土',
        // 'Bosnia and Herz.': '波斯尼亚和黑塞哥维那',
        // 'Central African Rep.': '中非',
        // 'Dem. Rep. Congo': '刚果民主共和国',
        // 'Congo': '刚果',
        // 'N. Cyprus': '北塞浦路斯',
        // 'Czech Rep.': '捷克',
        // 'Eq. Guinea': '赤道几内亚',
        // 'Korea': '韩国',
        // 'Lao PDR': '老挝',
        // 'Dem. Rep. Korea': '朝鲜',
        // 'W. Sahara': '西撒哈拉',
        // 'S. Sudan': '南苏丹',
        // 'Solomon Is.': '所罗门群岛',
        // 'Serbia': '塞尔维亚',
        // 'Tanzania': '坦桑尼亚',
        // 'United States': '美国'
      }
      for (let item of this.topStorageInventorySummary) {
        if (json[item.countryName]) {
          data[json[item.countryName]] = {
            name: item.countryName,
            nameMap: json[item.countryName],
            line1: item.inventoryQuantity,
            line2: item.inventoryTotalAmount
          }
        }
      }
      this.$echarts.registerMap('world', world)
      let mapBox = document.getElementById('cc-charts1')
      let that = this
      let myEcharts = this.$echarts.init(mapBox)
      let option = {
        title: {
          // text: '中国航空航线图' //整个的标题
        },
        // geo用于显示地图坐标
        geo: {
          map: 'world', // 导入的china.js，该文件中注册的china地图。
          zoom: 0.8, // 默认显示的缩放倍数
          roam: true, // 是否开启鼠标的缩放
          scaleLimit: { // 控制鼠标缩放的最小倍数，最大倍数
            min: 1,
            max: 1
          },
          tooltip: {
            // trigger: 'axis',
            enterable: true
            // formatter: function(params) {
            //   console.log(params, '11111')
            //   debugger
            // }
          },
          label: {
            show: false, // 控制省份名称的显示隐藏
            offset: [0, 0], // 控制省份名称的偏移量
            color: 'white' // 省份名称的字体颜色
            // formatter: (d) => {
            //   console.log('d+++++++++++', d)
            // }
          },
          // 板块的颜色
          itemStyle: {
            areaColor: '#3151f0', // 每个板块的颜色
            borderColor: '#404a59' // 板块的边界颜色
          },
          // 鼠标移入某板块的样式设置
          emphasis: {
            // 移入该板块时的板块颜色
            itemStyle: {
              areaColor: 'red'
            },
            // 省份的名称颜色
            label: {
              color: 'white'
            },
            tooltip: {
              enterable: true
            }
          }
        }
      }
      myEcharts.setOption(option, true)
      myEcharts.on('mouseover', function (params) {
        if (data[params.name]) {
          that.tips = data[params.name]
          that.tipsShow = true
          that.$forceUpdate()
          let tips = document.getElementById('tips')
          tips.style.left = params.event.offsetX + 60 + 'px'
          tips.style.top = params.event.offsetY + 40 + 'px'
        } else {
          that.tipsShow = false
        }
      })
    },
    initCharts2 () {
      let data1 = this.topQuantityAmountTrendChartSummary.map(item => { return (item.totalPrice / 10000).toFixed(2) })
      let data2 = this.topQuantityAmountTrendChartSummary.map(item => { return item.availableQty })
      let xData = this.topQuantityAmountTrendChartSummary.map(item => { return item.monthDay })
      var chartDom = document.getElementById('cc-charts2')
      var myChart = this.$echarts.init(chartDom)
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        grid: {
          top: '10%',
          left: '4%',
          right: '4%',
          bottom: '0%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xData,
            axisPointer: {
              type: 'shadow'
            },
            axisLabel: {
              textStyle: {
                color: '#fff'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '库存数量（单位：件）',
            textStyle: {
              color: '#fff'
            },
            axisLabel: {
              formatter: '{value} ',
              textStyle: {
                color: '#fff'
              }
            }
          },
          {
            type: 'value',
            name: '库存金额（单位：万元）',
            textStyle: {
              color: '#fff'
            },
            axisLabel: {
              formatter: '{value} ',
              textStyle: {
                color: '#fff'
              }
            }
          }
        ],
        series: [
          {
            name: '库存数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + '件'
              }
            },
            barWidth: 16,
            data: data2
          },
          {
            name: '库存金额',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '万'
              }
            },
            data: data1
          }
        ]
      }
      option && myChart.setOption(option)
    },
    initCharts3 () {
      let data = this.topInventoryAgeQuantitySummary
      data.forEach(item => {
        item['name'] = item.warehouseName
        item['value'] = item.availableQty
      })
      var chartDom = document.getElementById('cc-charts3')
      var myChart = this.$echarts.init(chartDom)
      let option
      option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: '0',
          textStyle: {
            color: '#fff'
          }
        },
        series: [
          {
            name: '库龄数量统计',
            type: 'pie',
            radius: ['40%', '80%'],
            center: ['50%', '46%'],
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              alignTo: 'edge',
              formatter: '{name|{c}} {d}%\n{time|{b}}',
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {}
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80
            },
            labelLayout: function (params) {
              const isLeft = params.labelRect.x < myChart.getWidth() / 2
              const points = params.labelLinePoints
              // Update the end point.
              points[2][0] = isLeft
                ? params.labelRect.x
                : params.labelRect.x + params.labelRect.width
              return {
                labelLinePoints: points
              }
            }
          }
        ]
      }
      option && myChart.setOption(option)
    }
  }
}
</script>

<style lang='scss' scoped>
  .cc{
    .head-list{
      display: flex;
      margin-top: 30px;
      margin-bottom: 24px;
      justify-content: space-between;
      padding: 0 150px;
      color:#fff;
      font-size:24px;
      .num{
        color: rgb(71,166,234);
        font-size:24px;
        line-height: 40px;
        text-align: center;
      }
      .text{
        font-size:18px;
        line-height: 24px;
      }
    }
    .content{
      border: 1px solid rgb(71,166,234);
      border-radius: 6px;
      padding: 16px 20px 32px 20px;
      margin:32px 0 16px 0;
      // position: relative;
      .top{
        display: flex;
        font-size:18px;
        .icon{
          width: 20px;
          height: 20px;
          border-radius: 4px;
          background: rgb(71,166,234);
          margin-right:16px;
        }
      }
      .title{
        text-align: center;
        display: flex;
        justify-content: space-around;
        padding: 0 100px;
        font-size:18px;
      }
    }
    .line1{
      display: flex;
      height: 520px;
      margin-bottom:69px;
      margin-left:30px;
    }
    // .line2{
    //   display: flex;
    //   height: 800px;
    //   margin-bottom:72px;
    //   margin-left:20px;
    // }
    .w-70{
      width: 1050px;
      height: 100%;
      // margin-left:32px;
    }
    .w-30{
      width: 710px;
      height: 100%;
      margin-left:0;
      margin-right:20px;
    }
    .w-100{
      /* width: calc(100% - 112px); */
      width: 100%;
      height: 100%;
      margin-right:32px;
      // margin-left:32px;
    }
    #cc-charts1{
      margin-top:16px;
      width: 100%;
      height: 520px;
    }
    #cc-charts2{
      margin-top:8px;
      width: 100%;
      height: 480px;
    }
    #cc-charts3{
      margin-top:32px;
      width: 100%;
      height: 480px;
    }
    #tips{
      position: absolute;
      top: 0;
      left:0;
      background: rgba(0,0,0, 0.4);
      color:#fff;
      padding:12px 16px;
      border-radius: 4px;
      z-index: 888;
      width:100px;
      height:80px;
    }
    .filter-list{
      display: flex;
      align-items: center;
      margin:10px 0 8px 0;
      justify-content: space-around;
      .filter-item{
        display: flex;
        align-items: center;
        .filter-text{
          font-size:16px;
          margin-right:16px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/compontents/cc.vue